import ReviewPacing from './component'
export default ReviewPacing
